import { CellView } from "./CellView";
import { injectable } from "@launchtray/tsyringe-async";
import { TriangleView } from "../triangles/TriangleView";
import { GameUIResourcesPackage } from "../../../../preloader/resources/GameUIResourcesPackage";

@injectable()
export class CellViewFactory {
    public constructor(
        private readonly gameUIResourcesPackage: GameUIResourcesPackage
    ) { }

    public createCellView(triangle1: TriangleView, triangle2: TriangleView): CellView {
        return new CellView(
            this.gameUIResourcesPackage,
            triangle1,
            triangle2
        );
    }
}